export const GENDER_IDENTITY_LIST = [
  {
    label: 'Mulher cisgênera',
    value: 'Mulher cisgênera'
  },
  {
    label: 'Mulher trans',
    value: 'Mulher trans'
  },
  {
    label: 'Homem cisgênero',
    value: 'Homem cisgênero'
  },
  {
    label: 'Homem trans',
    value: 'Homem trans'
  },
  {
    label: 'Pessoa não-binária',
    value: 'Pessoa não-binária'
  },
  {
    label: 'Prefiro não responder',
    value: 'Prefiro não responder'
  },
  {
    label: 'Nenhuma das opções listadas',
    value: 'Nenhuma das opções listadas'
  }
]

export const NATIONALITY_LIST = [
  {
    label: 'Brasileiro(a)',
    value: 'brasileira'
  }
  // Leave this commented until we have a way to deal with foreigners
  // {
  //   label: 'Estrangeiro(a)',
  //   value: 'estrangeira'
  // }
]

export const GENDER_LIST = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' },
  { value: 'O', label: 'Outro' }
]

export const UF_LIST = [
  { value: 'AC', label: 'AC' },
  { value: 'AL', label: 'AL' },
  { value: 'AP', label: 'AP' },
  { value: 'AM', label: 'AM' },
  { value: 'BA', label: 'BA' },
  { value: 'CE', label: 'CE' },
  { value: 'DF', label: 'DF' },
  { value: 'ES', label: 'ES' },
  { value: 'GO', label: 'GO' },
  { value: 'MA', label: 'MA' },
  { value: 'MT', label: 'MT' },
  { value: 'MS', label: 'MS' },
  { value: 'MG', label: 'MG' },
  { value: 'PA', label: 'PA' },
  { value: 'PB', label: 'PB' },
  { value: 'PR', label: 'PR' },
  { value: 'PE', label: 'PE' },
  { value: 'PI', label: 'PI' },
  { value: 'RJ', label: 'RJ' },
  { value: 'RN', label: 'RN' },
  { value: 'RS', label: 'RS' },
  { value: 'RO', label: 'RO' },
  { value: 'RR', label: 'RR' },
  { value: 'SC', label: 'SC' },
  { value: 'SP', label: 'SP' },
  { value: 'SE', label: 'SE' },
  { value: 'TO', label: 'TO' }
]
